<h2 class="text extra-small med-unit-info-card med-unit-info-card__title mt-0 mb-3">
  <ng-content select="[title]"></ng-content>
</h2>

<p class="text small med-unit-info-card med-unit-info-card__content m-0">
  <ng-content></ng-content>
</p>
